<template>
  <div class="tabs" :id="id">
    <div class="tabs__btns" ref="tabs_btns">
      <ul>
        <template v-for="item of tabs">
          <li
            class="tabs_item"
            :key="item.id"
            :class="{ active: currentTab === item.id }"
            @click="handleChangeTab(item)"
          >
            {{ item.title }}
          </li>
        </template>
      </ul>
    </div>
    <div class="tabs__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    tabs: {
      type: Array,
      default: () => [],
    },
    defaultTab: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    currentTab: null,
  }),
  methods: {
    handleChangeTab(item) {
      this.currentTab = item.id
      this.$emit('change-tab', item)
    },
  },
  created() {
    if (!this.defaultTab) {
      this.currentTab = this.tabs[0].id
    } else {
      this.currentTab = this.defaultTab
    }
  },
  mounted() {
    const tabs = document.getElementById(this.id)
    const liTags = tabs.getElementsByTagName('li')
    for (let item of liTags) {
      item.style.width = `${100 / liTags.length}%`
    }
  },
}
</script>

<style lang="scss" scoped>
@import 'tabs.scss';
</style>
